// js
import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { updateDSAAreaNote } from '../../actions/dsaActions';
import { connect } from 'react-redux';
// css
import '../../styles/components/common/DSANote.scss';


class DSANote extends Component {
  constructor(props) {
    const dsaArea = props.dsaArea || {};
    super(props);

    this.state = {
      expanded: false,
      changed: false,
      value: dsaArea.note || ''
    };
  }

  componentWillReceiveProps(nextProps) {
    const dsaArea = nextProps.dsaArea || {};
    this.setState({value: dsaArea.note || '', changed: false});
  }

  toggleExpanded() {
    this.save();
    this.setState({expanded: !this.state.expanded});
  }

  save() {
    if (this.state.expanded && this.state.changed && this.props.dsaArea) {
      this.props.updateDSAAreaNote(this.props.dsaArea.id, this.state.value);
      this.setState({changed: false});
    }
  }

  handleChange(event) {
    this.setState({value: event.target.value.substr(0, 512), changed: true});
  }

  getClassNames() {
    return classnames({
      'dsa-note': true,
      'active': this.state.expanded
    });
  }

  getTitle(area) {
    return area.title
      .replace('Operations', 'Opps')
      .replace('Application', 'App')
      .replace('Development', 'Dev')
      .replace('Security', 'Sec')
      .replace('Compliance', 'Comp')
      .replace('and', '&')
      + ' Notes';
  }

  render() {
    if (this.props.dsaArea) {
      return (
        <div className={this.getClassNames()}>
          <div className='dsa-note-title' onClick={() => this.toggleExpanded()}>{this.getTitle(this.props.area)}</div>
          <div className='dsa-note-content'>
            <textarea value={this.state.value} onChange={(e) => this.handleChange(e)} />
            <button onClick={() => this.save()} disabled={!this.state.changed} className='btn btn-sm btn-primary'>Save</button>
          </div>
          <i className='icon icon-cancel-x' onClick={() => this.toggleExpanded()} />
        </div>
      );
    } else {
      return null;
    }
  }
}

DSANote.propTypes = {
  area: PropTypes.object,
  dsaArea: PropTypes.object,
  updateDSAAreaNote: PropTypes.func
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateDSAAreaNote: (id, note) => dispatch(updateDSAAreaNote(id, note))
  };
};

export default connect(null, mapDispatchToProps)(DSANote);



// WEBPACK FOOTER //
// ./src/components/common/DSANote.js